export class RestoreDto {
  password: string;
  confirmPassword: string;
  token: string;
  isUbs: boolean;
}
